module.exports = "<span>\r\n    <button (click)=\"invokeParentMethod()\" class=\"btn btn-info\">\r\n        <i class=\"fa fa-download\"></i>\r\n    </button>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/eop-button/eop-button.component.html
// module id = 2332
// module chunks = 66